<div
  class="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-cover bg-center"
  style="background-image: url('/login_background1.jpg')"
>
  <div class="pointer-events-none absolute inset-0 bg-slate-900/72"></div>

  <div class="relative z-10 flex w-full flex-col items-center px-4">
    <img class="mb-8 h-10 w-auto" src="/Aksia_Logo_white.png" alt="Aksia" />

    <p class="max-w-xs text-center text-sm text-white/80">
      This page is part of an Aksia application's sign-in flow and isn't
      intended to be opened on its own. To continue, open the application you
      wanted to use and sign in from there.
    </p>

    <p class="mt-4 max-w-xs text-center text-sm text-white/80">
      If you're trying to reset a forgotten password, you can do that here:
    </p>

    <a
      routerLink="/forgot-password"
      class="mt-4 rounded-lg bg-slate-100/95 px-6 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-200"
    >
      Forgot password
    </a>
  </div>

  <footer
    class="absolute bottom-0 w-full py-4 text-center text-xs text-white/40"
  >
    <a class="transition hover:text-white/70" href="mailto:support@aksia.com">
      Contact support
    </a>
  </footer>
</div>
